/* eslint-disable max-lines-per-function */
/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable functional/immutable-data */
import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
  useEffect,
} from 'react'
import { LatLngExpression } from 'leaflet'
// eslint-disable-next-line id-length
import L from 'leaflet'
import drawLocales from 'leaflet-draw-locales'
import { FeatureGroup, useMapEvents, Marker } from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'
import type { IGeographical } from '../../interfaces'
import { interestPointIcon } from './InterestPointIcon'

// Configuração dos ícones padrão do Leaflet
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png'

interface DrawInMapProps {
  readonly value: any
  readonly onChange: (value: any) => void
  readonly limit?: number
}

const DrawInMap = forwardRef(
  ({ value, onChange, limit }: DrawInMapProps, ref) => {
    const [markerList, setMarkerList] = useState(value)

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const featureGroupRef = useRef<any>(null)

    useEffect(() => {
      const defaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconRetinaUrl: iconRetina,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      })

      L.Marker.prototype.options.icon = defaultIcon
      L.Icon.Default.mergeOptions({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconRetinaUrl: iconRetina,
      })

      drawLocales('pt')
    }, [])

    const handleDrawWithCreate = useCallback(
      (event: L.DrawEvents.Created) => {
        const layer = event.layer

        if (layer instanceof L.Marker) {
          layer.setIcon(interestPointIcon)

          const latlng = layer.getLatLng()

          const geo: IGeographical = {
            id: Date.now(),
            name: '',
            color: '',
            lat: latlng.lat as unknown as LatLngExpression,
            lng: latlng.lng as unknown as LatLngExpression,
            area: undefined,
            radius: undefined,
            initialDate: undefined,
            endDate: undefined,
          }

          setMarkerList(geo)
          onChange(geo)
        }
      },
      [onChange]
    )

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleDrawEdit = useCallback(
      (event: L.DrawEvents.Edited) => {
        const { layers } = event
        const editedLayers = layers.getLayers()

        if (editedLayers.length === 0) return

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedMarkers = editedLayers.map((layer: any) => {
          const latlng = layer.getLatLng()

          return {
            id: Date.now(),
            name: '',
            color: '',
            lat: latlng.lat as unknown as LatLngExpression,
            lng: latlng.lng as unknown as LatLngExpression,
            area: undefined,
            radius: undefined,
            initialDate: undefined,
            endDate: undefined,
          }
        })

        setMarkerList(updatedMarkers[0])
        onChange(updatedMarkers[0])
      },
      [onChange]
    )

    const handleDrawWithDelete = useCallback(() => {
      setMarkerList([])
      onChange([])
    }, [onChange])

    // Componente interno para capturar eventos do mapa
    function RightClickHandler() {
      useMapEvents({
        contextmenu: (event) => {
          // Verifica se ainda pode adicionar mais marcadores
          if (
            markerList &&
            Array.isArray(markerList) &&
            markerList.length >= (limit ?? 1)
          ) {
            return
          }

          const { lat, lng } = event.latlng

          const geo: IGeographical = {
            id: Date.now(),
            name: '',
            color: '',
            lat: lat as unknown as LatLngExpression,
            lng: lng as unknown as LatLngExpression,
            area: undefined,
            radius: undefined,
            initialDate: undefined,
            endDate: undefined,
          }

          setMarkerList(geo)
          onChange(geo)

          // Adiciona o marcador visualmente ao mapa
          if (featureGroupRef.current) {
            featureGroupRef.current.clearLayers() // Limpa todos os marcadores antes de adicionar o novo
            const marker = L.marker([lat, lng], { icon: interestPointIcon })
            featureGroupRef.current.addLayer(marker)
          }
        },
      })
      return null
    }

    // Supondo que handleDrawWithCreate já exista:
    const handleDrawWithCreateRef = (latLng) => {
      const { lat, lng } = latLng
      if (featureGroupRef.current) {
        featureGroupRef.current.clearLayers() // Limpa todos os marcadores antes de adicionar o novo
        const marker = L.marker([lat, lng], { icon: interestPointIcon })
        featureGroupRef.current.addLayer(marker)
      }
      const geo: IGeographical = {
        id: Date.now(),
        name: '',
        color: '',
        lat: lat as unknown as LatLngExpression,
        lng: lng as unknown as LatLngExpression,
        area: undefined,
        radius: undefined,
        initialDate: undefined,
        endDate: undefined,
      }

      setMarkerList(geo)
      onChange(geo)
    }

    useImperativeHandle(ref, () => ({
      handleDrawWithCreate: handleDrawWithCreateRef,
    }))

    return (
      <FeatureGroup ref={featureGroupRef}>
        {Array.isArray(markerList) &&
          markerList.map((marker) => (
            <Marker
              key={marker.id}
              position={[marker.lat, marker.lng]}
              icon={interestPointIcon}
            />
          ))}
        <EditControl
          position="bottomleft"
          onCreated={handleDrawWithCreate}
          onDeleted={handleDrawWithDelete}
          onEdited={handleDrawEdit}
          draw={{
            circle: false,
            rectangle: false,
            polygon: false,
            polyline: false,
            marker: false,
            circlemarker: false,
          }}
          edit={{
            edit: false,
            remove: false,
          }}
        />
        <RightClickHandler />
      </FeatureGroup>
    )
  }
)

export default DrawInMap
